import { isAllowedForBrand } from "@/utils/brand-restriction";

type BrandRestrictedPaymentMethod = {
  restrictByBrands?: boolean;
  allowedBrands?: string[];
};

export function isPaymentMethodAllowedForBrand(
  paymentMethod: BrandRestrictedPaymentMethod,
  brandId?: string
): boolean {
  return isAllowedForBrand(paymentMethod, brandId);
}
